export default __webpack_public_path__ + "static/media/PriyalChheda.4b935a4b.png";